// Libraries
import { CustomSelect, DatePicker, Modal, FormElems } from '../../components';
import cross from '../../static/images/remove.png';
import { dateOptions } from '../../utils/constants/commonValues';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import moment from 'moment';

// Components

// Assets

// Constants

// Styles
import './customDate.scss';

const formatDateValue = (startDate, endDate, nbValues) => {
    if (startDate && endDate && nbValues.value === 'custom') {
        const startD = moment(startDate).format('DD-MM-YYYY');
        const endD = moment(endDate).format('DD-MM-YYYY');
        return `${startD} to ${endD}`;
    }
    return nbValues.label;
};

const ValueContainer = ({ children, ...props }) => {
    const { getValue } = props;
    const { startDate, endDate, prevDateValue } = props.selectProps;
    const newChildren = [...children];
    const nbValues = getValue().find(item => item.value === 'custom');
    if (startDate && endDate && nbValues) {
        newChildren[0] = formatDateValue(startDate, endDate, nbValues);
        return (
            <components.ValueContainer {...props}>
                <div className="custom-datelabel">{newChildren}</div>
            </components.ValueContainer>
        );
    } else if (
        nbValues &&
        prevDateValue.value !== 'custom' &&
        nbValues.value === 'custom'
    ) {
        newChildren[0] = `${prevDateValue.label || 'Custom'}`;
        return (
            <components.ValueContainer {...props}>
                {newChildren}
            </components.ValueContainer>
        );
    }

    return (
        <components.ValueContainer {...props}>
            {children}
        </components.ValueContainer>
    );
};

const Option = props => {
    const { data } = props;
    return (
        <components.Option {...props}>
            <div className={data.value}>{data.label}</div>
        </components.Option>
    );
};

/**
 * CustomDate Component
 *
 * @param {Object} props - React component props
 */

const CustomDatePicker = props => {
    const {
        startDate,
        focusedInput,
        endDate,
        setStartDate,
        setEndDate,
        setFocusedInput,
        isCustomDate,
        closeModal,
        applyDate,
    } = props;
    return (
        <Modal
            modalIsOpen={isCustomDate}
            closeModal={closeModal}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            customWrapperClass="datepicker-modal"
        >
            <div className="datepicker-wrap">
                <span className="crossIcon" onClick={closeModal}>
                    <img src={cross} alt="Close Icon" />
                </span>
                <h1>Select Custom Date</h1>
                <DatePicker
                    name="customDate"
                    startDateId="customDateStartDate"
                    endDateId="customDateEndDate"
                    label="Date Range"
                    startDate={startDate}
                    endDate={endDate}
                    focusedInput={focusedInput}
                    onSetStartDate={startDate => {
                        setStartDate(startDate);
                    }}
                    onSetEndDate={endDate => {
                        setEndDate(endDate);
                    }}
                    onFocusedInput={focusedInput => {
                        setFocusedInput(focusedInput);
                    }}
                />
                <div className="apply-date">
                    <FormElems.Button
                        buttonType="primary"
                        text="Apply"
                        isDisable={!(startDate && endDate)}
                        handleClick={() => applyDate()}
                    />
                </div>
            </div>
        </Modal>
    );
};

const CustomDate = props => {
    const {
        setDateValue,
        setPrevDateValue,
        prevDateValue,
        defaultSelected,
    } = props;
    const [selectedDate, setSelectedDate] = useState({});
    const [isCustomDate, setIsCustomDate] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);

    useEffect(() => {
        // Create a new session on app load
        handleDateSelect(defaultSelected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDateSelect = values => {
        if (values.value === 'custom') {
            setIsCustomDate(true);
        } else {
            setIsCustomDate(false);
            setStartDate(null);
            setEndDate(null);
            setPrevDateValue(values);
            setDateValue({ value: values.value, startDate, endDate });
        }
        setSelectedDate(values);
    };
    const closeModal = () => {
        setIsCustomDate(false);
        if (prevDateValue.value !== selectedDate.value) {
            setStartDate(null);
            setEndDate(null);
            setSelectedDate(prevDateValue);
        }
    };
    const applyDate = () => {
        setIsCustomDate(false);
        setPrevDateValue({ label: 'Custom', value: 'custom' });
        setDateValue({ value: 'custom', startDate, endDate });
    };
    const selectProps = {
        startDate,
        endDate,
        isCustomDate,
        setStartDate,
        setEndDate,
        setFocusedInput,
        focusedInput,
        prevDateValue,
        selectedDate,
        setIsCustomDate,
    };

    return (
        <>
            <div className="custom-date-dropdown">
                <CustomSelect
                    name="date"
                    customClass="wrapper-select"
                    options={dateOptions}
                    components={{
                        Option,
                        ValueContainer,
                    }}
                    value={dateOptions.filter(
                        option => option.label === selectedDate.label
                    )}
                    isSearchable
                    data={selectedDate}
                    selectProps={selectProps}
                    closeMenuOnSelect={true}
                    placeholder="Select Date"
                    onChange={handleDateSelect}
                />
                {isCustomDate ? (
                    <CustomDatePicker
                        {...selectProps}
                        closeModal={closeModal}
                        applyDate={applyDate}
                    />
                ) : null}
            </div>
        </>
    );
};

CustomDatePicker.propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    setStartDate: PropTypes.func,
    setFocusedInput: PropTypes.func,
    focusedInput: PropTypes.string,
    setEndDate: PropTypes.func,
    setIsCustomDate: PropTypes.bool,
    isCustomDate: PropTypes.func,
    closeModal: PropTypes.func,
    applyDate: PropTypes.func,
};

Option.propTypes = {
    data: PropTypes.object,
    isSelected: PropTypes.bool,
    selectProps: PropTypes.object,
    innerRef: PropTypes.string,
    innerProps: PropTypes.object,
};

ValueContainer.propTypes = {
    hasValue: PropTypes.bool,
    children: PropTypes.array,
    getValue: PropTypes.func,
    selectProps: PropTypes.object,
};

CustomDate.propTypes = {
    customClass: PropTypes.bool,
    setDateValue: PropTypes.func,
    setPrevDateValue: PropTypes.func,
    prevDateValue: PropTypes.object,
    defaultSelected: PropTypes.object,
};

export default CustomDate;
